/** 系统盘容量默认值（Gi） */
export const DEFAULT_SYSTEM_DISK_SIZE_MIN = 10;
export const DEFAULT_SYSTEM_DISK_SIZE_MAX = 100;
export const DEFAULT_SYSTEM_DISK_SIZE_GI = 10;
export const DEFAULT_SYSTEM_DISK_SIZE_MARK_COUNT = 5;

/** 卡片 / 弹窗文案 */
export const SYSTEM_DISK_RESOURCE_ADD_LABEL = '系统盘配置';
export const SYSTEM_DISK_RESOURCE_MODAL_TITLE = '系统盘配置';

/** VolumeOptionLabel 图标（与云盘卡片一致） */
export const SYSTEM_DISK_RESOURCE_ICON = 'icon-yunpan';

/** 弹窗内容量字段（写回主表单时映射到 paths.size） */
export const SYSTEM_DISK_MODAL_SIZE_FIELD = 'systemDiskSize';

/** 弹窗内计价厂商设备前缀 */
export const SYSTEM_DISK_MODAL_PRICING_FIELD = 'systemDiskPricing';
